import { evalStatExpression } from "../systems/evalStatExpression.js";
import type { RelicDef } from "../models/RelicEffect.js";
import { t } from "../i18n/i18n.js";

/**
 * 유물 효과 1줄 라벨 (현재 레벨 기준 값). 미보유(count 0)는 Lv1 미리보기.
 * RelicTabView 카드 + RelicDetailPopup 공유 (effectExpr×level 계산 단일 출처).
 */
export function relicEffectText(def: RelicDef, count: number): string {
  const lv = Math.max(1, count);
  const value = Math.round(evalStatExpression(def.effectExpr, def.base, lv));
  return t(`relic.effect.${def.effectType}`, { value });
}

/** 레벨·진행 라벨 "Lv.{count} · {count}/{count+1}" (1개=Lv1, 다음 레벨 = 현재 + 1). */
export function relicLevelText(count: number): string {
  return t("relic.levelProgress", { level: count, count, next: count + 1 });
}
